import {
  jb_timeline_css_default
} from "./chunk.K2QX2PSO.js";
import {
  ScrollTrigger
} from "./chunk.SY5TJF72.js";
import {
  gsapWithCSS
} from "./chunk.MDJ4MKC6.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Spaceable
} from "./chunk.JI7MO3NT.js";
import {
  ChangesBackgroundColor
} from "./chunk.XYH4LHGJ.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r2 as r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-timeline/jb-timeline.ts
var JbTimeline = class extends Spaceable(ChangesBackgroundColor(i)) {
  constructor() {
    super(...arguments);
    this.sort = "oldestFirst";
    this._lastOffsetTop = 0;
  }
  connectedCallback() {
    super.connectedCallback();
    this._timelineArray = this._groupBy(this.timelineItems, "year");
    this._timelineKeys = this.sort === "oldestFirst" ? Object.keys(this._timelineArray) : Object.keys(this._timelineArray).reverse();
  }
  async firstUpdated() {
    await this.updateComplete;
    gsapWithCSS.registerPlugin(ScrollTrigger);
    this._animatedElements.forEach((element) => {
      this._addAnimation(element);
    });
    this._lastOffsetTop = this.offsetTop;
    window.setInterval(() => {
      if (this.offsetTop !== this._lastOffsetTop) {
        this._lastOffsetTop = this.offsetTop;
        ScrollTrigger.refresh();
      }
    }, 100);
  }
  _addAnimation(element) {
    ScrollTrigger.create({
      trigger: element,
      onEnter: () => {
        this._animateElement(element);
      },
      onEnterBack: () => {
        this._animateElement(element);
      },
      onLeave: () => {
        this._hide(element);
      },
      onLeaveBack: () => {
        this._hide(element);
      }
    });
  }
  _animateElement(element) {
    gsapWithCSS.fromTo(
      element,
      { scale: 0.7, autoAlpha: 0 },
      {
        duration: 0.7,
        delay: 0.1,
        scale: 1,
        autoAlpha: 1,
        ease: "ease-in",
        overwrite: "auto"
      }
    );
  }
  _getContentSpacingProperties() {
    return { colsMdUp: 8, grid: true };
  }
  // https://stackoverflow.com/a/71505541
  _groupBy(arr, prop) {
    return arr.reduce((memo, x) => {
      if (!memo[x[prop]]) {
        memo[x[prop]] = [];
      }
      memo[x[prop]].push(x);
      return memo;
    }, {});
  }
  _hide(element) {
    gsapWithCSS.set(element, { autoAlpha: 0 });
  }
  render() {
    return this._timelineKeys.map(
      (key) => b`<div class="timeline-item">
          <div class="timeline-ray"></div>
          <jb-heading
            class="year"
            variant="heading-lg"
            >${key}</jb-heading
          >
          ${this._timelineArray[key].map(
        (elm) => b`
              ${elm.image ? b`
                      <div class="picture-wrapper">
                        <span class="dot"></span>
                        <jb-picture
                          .alt=${elm.image.alt}
                          .imgData=${elm.image.imgData}
                          .lazy=${elm.image.lazy}
                          aspect="aspect_3by2"
                          fit="cover"
                        ></jb-picture>
                      </div>
                    ` : A}
              <div class="info">
                <span class="dot"></span>
                <div class="infoblock">
                  <jb-heading
                    class="event"
                    offset="1"
                    variant="heading-sm"
                    >${elm.headline}</jb-heading
                  >
                  <p>${elm.description}</p>
                </div>
              </div>
            `
      )}
        </div>`
    );
  }
};
JbTimeline.styles = [reset_css_default, jb_timeline_css_default];
__decorateClass([
  n()
], JbTimeline.prototype, "sort", 2);
__decorateClass([
  n({ type: Array })
], JbTimeline.prototype, "timelineItems", 2);
__decorateClass([
  r("jb-picture, .infoblock, .dot")
], JbTimeline.prototype, "_animatedElements", 2);
JbTimeline = __decorateClass([
  customElement("jb-timeline")
], JbTimeline);

export {
  JbTimeline
};
